import { Injectable } from '@angular/core';
@Injectable({
  providedIn: 'root'
})
export class CdkMessageService {
    private readonly _bus;
    private readonly _uid;
    constructor(){};
    /**
     * Dispat
     * ch()
     */
    dispatch(message: any): void{};
    /**
     * message()
     */
    message(){};
}